import { cn, CryptoIcon, getNetworkName, SimpleSelectContent } from '@valiant/ui-shared'
import { ChevronDown } from 'lucide-react'
import { Select, SelectItem, SelectTrigger, SelectValue } from '@valiant/ui-shared'

interface Mint {
  id: string
  symbol: string
  name: string
  chain: string
  image?: string | null
}

interface MintSelectorProps {
  value: string
  onValueChange: (value: string) => void
  mints: Mint[]
  label: string
  placeholder: string
  excludeId?: string
}

const BigChevronDownIcon = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'flex items-center justify-center bg-main rounded-md w-8 h-9 text-white',
      className,
    )}
  >
    <ChevronDown className="shrink-0 h-6 w-6 text-white" />
  </div>
)

export const MintSelector = ({
  value,
  onValueChange,
  mints,
  label,
  placeholder,
  excludeId,
}: MintSelectorProps) => {
  const selectedMint = mints.find((mint) => mint.id === value)

  return (
    <div className="relative">
      <label className="text-sm font-medium text-gray-700 mb-2 block absolute top-0 -translate-y-1/2 left-4.5 bg-white px-1">
        {label}:
      </label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger
          className="w-full px-4.5 py-2.5 cursor-pointer"
          size="lg"
          OverrideChevron={BigChevronDownIcon}
        >
          <SelectValue placeholder={placeholder}>
            {selectedMint && (
              <div className="flex items-center gap-2">
                <CryptoIcon
                  symbol={selectedMint.symbol}
                  imageOverride={selectedMint.image || undefined}
                  className="w-6 h-6"
                />
                <span className="text-lg font-semibold text-gray-900">{selectedMint.symbol}</span>
              </div>
            )}
          </SelectValue>
        </SelectTrigger>
        <SimpleSelectContent>
          {mints
            .filter((mint) => mint.id !== excludeId)
            .map((mint, index) => (
              <div key={mint.id}>
                <SelectItem value={mint.id} className="py-3">
                  <div className="flex items-center gap-3">
                    <CryptoIcon
                      symbol={mint.symbol}
                      imageOverride={mint.image || undefined}
                      className="w-8 h-8"
                    />
                    <div className="flex flex-col">
                      <span className="text-lg font-bold text-gray-900">{mint.symbol}</span>
                      <span className="text-sm text-gray-500">{getNetworkName(mint.chain)}</span>
                    </div>
                  </div>
                </SelectItem>
                {index < mints.filter((mint) => mint.id !== excludeId).length - 1 && (
                  <div className="border-b border-gray-200 mx-4" />
                )}
              </div>
            ))}
        </SimpleSelectContent>
      </Select>
    </div>
  )
}
